import { Configuration } from '@/generated/types/typescript-axios';

export const ApiConfig = () => {
  if (typeof window !== 'undefined') {
    const jwtToken = window.localStorage.getItem('SaaSusIdToken');
    const apiConfig = new Configuration({
      accessToken: jwtToken || 'dummyToken',
      basePath: 'https://a35ppgidahs5wlpnz4z25fduwu0ouhoz.lambda-url.ap-northeast-1.on.aws',
    });
    return apiConfig;
  }
};

export const ApiConfig2 = () => {
  if (typeof window !== 'undefined') {
    const jwtToken = window.localStorage.getItem('SaaSusIdToken');
    const apiConfig = new Configuration({
      accessToken: jwtToken || 'dummyToken',
      basePath: 'https://clty6wazlgq4zjieiuqzugcvo40ipqmu.lambda-url.ap-northeast-1.on.aws',
    });
    return apiConfig;
  }
};
